export default __webpack_public_path__ + "static/media/icon_repeater.332d3bd0.svg";